module.exports = __webpack_public_path__ + "img/P150T_weapon_17.02216189.png";